import angular from 'angular';

angular.module('history').directive('topbarHistoryInvoicesPassive', function() {
    return {
        restrict: 'E',
        replace: true,
        scope: {
            context: "="
        },
		template: require('./topbar-history-invoices-passive.html'),
        controller: ["$scope", "$element", "$attrs", "$timeout", "$mdSidenav", "connection", "offlineDialog", "alertDialog", function($scope, $element, $attrs, $timeout, $mdSidenav, connection, offlineDialog, alertDialog) {
            $scope.isConnectionOffline = function() {
                return connection.isOffline();
            };

            $scope.openOfflineDialog = function() {
                offlineDialog.show();
            };
            $scope.openLeftMenu = function() {
                $mdSidenav('left').toggle();
            };
            
        }]
    };
});
